export const INIT_DEVICE_SESSION = "/api/v1/sec/sync_device_session";
export const GET_USER_T = "/api/gt";
export const MORE_APPS = "/api/more_apps";
export const APPLY_FACE_SWAP = "/api/new_Filter/Face_SwapV2_Web";
export const COMPLETED_IMAGE = "/api/new_checkCompletedImageWeb";
export const EXTRACT_FACES_MULTI = "/api/new_Filter/extract_faces_multi_web";
export const APPLY__MULTI_FACE_SWAP = "/api/new_Filter/multi_face_swapV2_Web";
export const DIET_PLAN_DELETE_USER = "/api/dietplan/users/delete";
export const DIET_PLAN_SELECT_COUNTRY = "/api/dietplan/country_state/countries";